import { Dialog } from "@themes/pollinator/ui/Dialog";

export type Props = {
  isOpen: boolean;
  currentDeviceLabel: string;
  suggestedTargetLabel: string;
  onSwitch: () => void | Promise<void>;
  onUseAnyway: () => void;
  onDismiss: () => void;
};

export function IPhoneMicDialog({
  isOpen,
  currentDeviceLabel,
  suggestedTargetLabel,
  onSwitch,
  onUseAnyway,
  onDismiss,
}: Props) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onDismiss}
      title="Your iPhone is the active microphone"
      description={`Audio is being picked up from "${currentDeviceLabel}" via macOS Continuity. Switch to "${suggestedTargetLabel}" for better quality.`}
      isWithActions
      primaryButtonText="Switch microphone"
      onPrimaryClick={onSwitch}
      secondaryButtonText="Use iPhone anyway"
      onSecondaryClick={onUseAnyway}
    />
  );
}
